// frontend/src/services/announcementsApi.js
import { http } from "./http";

function buildQuery(params = {}) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    q.set(k, String(v));
  });
  const qs = q.toString();
  return qs ? `?${qs}` : "";
}

/* -------------------------------------------------------------------------- */
/* ADMIN                                                                      */
/* -------------------------------------------------------------------------- */

/**
 * ADMIN — list announcements for a filter.
 * Backend: GET /api/admin/announcements?level=...&targetId=...
 * Returns: { ok:true, data:[...] } -> http() unwraps to [...]
 */
export function adminListAnnouncements(token, { level = "union", targetId } = {}) {
  return http(`/api/admin/announcements${buildQuery({ level, targetId })}`, { token });
}

/**
 * ADMIN — create announcement.
 * Backend: POST /api/admin/announcements
 *
 * body: {
 *   level, targetId?, title, body, publishAt?, expireAt?,
 *   audienceType?: "scope"|"group"|"users",
 *   audienceKey?: string,
 *   audienceJson?: object,
 *   userIds?: string[]
 * }
 */
export function adminCreateAnnouncement(
  token,
  {
    level,
    targetId,
    title,
    body,
    publishAt,
    expireAt,

    audienceType = "scope",
    audienceKey,
    audienceJson,
    userIds,
  } = {}
) {
  return http(`/api/admin/announcements`, {
    method: "POST",
    token,
    body: {
      level,
      targetId,
      title,
      body,
      publishAt,
      expireAt,

      audienceType,
      audienceKey,
      audienceJson,
      userIds,
    },
  });
}

/**
 * ADMIN — delete announcement by id.
 * Backend: DELETE /api/admin/announcements/:id
 */
export function adminDeleteAnnouncement(token, id) {
  return http(`/api/admin/announcements/${id}`, {
    method: "DELETE",
    token,
  });
}

/* -------------------------------------------------------------------------- */
/* BACKWARDS-COMPAT WRAPPERS (so old components don’t break)                  */
/* -------------------------------------------------------------------------- */

export function listAnnouncements(token, { level, levelId, targetId } = {}) {
  return adminListAnnouncements(token, { level, targetId: targetId ?? levelId });
}

export function createAnnouncement(token, body = {}) {
  // maps old "levelId" to "targetId"
  const {
    level,
    levelId,
    targetId,
    title,
    body: msgBody,
    publishAt,
    expireAt,

    audienceType,
    audienceKey,
    audienceJson,
    userIds,
  } = body || {};

  return adminCreateAnnouncement(token, {
    level,
    targetId: targetId ?? levelId ?? null,
    title,
    body: msgBody,
    publishAt,
    expireAt,
    audienceType,
    audienceKey,
    audienceJson,
    userIds,
  });
}

export function deleteAnnouncement(token, id) {
  return adminDeleteAnnouncement(token, id);
}

/* -------------------------------------------------------------------------- */
/* LEARNER                                                                     */
/* -------------------------------------------------------------------------- */

export function getLearnerFeed(token) {
  return http(`/api/announcements/feed`, { token });
}

/* -------------------------------------------------------------------------- */
/* INSTRUCTOR                                                                  */
/* -------------------------------------------------------------------------- */

export function instructorListAnnouncements(token, { churchId } = {}) {
  return http(`/api/instructor/announcements${buildQuery({ churchId })}`, { token });
}

export function instructorCreateAnnouncement(
  token,
  { title, body, publishAt, expireAt, churchId } = {}
) {
  return http(`/api/instructor/announcements`, {
    method: "POST",
    token,
    body: { title, body, publishAt, expireAt, churchId },
  });
}
